import React, { ComponentPropsWithoutRef, ReactElement } from 'react';

import { Table, TableProps } from 'modules/common/components/Table';
import { TableCellProps } from 'modules/common/components/Table/TableCell';
import { TableRowProps } from 'modules/common/components/Table/TableRow';

import { useStyles } from './useStyles';

export function StakingTable(props: TableProps): ReactElement {
  return <Table {...props} />;
}

function Body({
  className,
  ...params
}: ComponentPropsWithoutRef<typeof Table.Body>) {
  const { classes, cx } = useStyles();

  return (
    <Table.Body {...params} className={cx(classes.tableBody, className)} />
  );
}

function Cell({ className, ...params }: TableCellProps) {
  const { classes, cx } = useStyles();

  return <Table.Cell {...params} className={cx(classes.cell, className)} />;
}

function Row({ className, ...params }: TableRowProps) {
  const { classes, cx } = useStyles();

  return <Table.Row {...params} className={cx(classes.tableRow, className)} />;
}

StakingTable.Body = Body;
StakingTable.Cell = Cell;
StakingTable.Row = Row;
StakingTable.HeadCell = Table.HeadCell;
StakingTable.Head = Table.Head;
